import data from './data.md?raw';
import links from './links.md?raw';
import image from './assets/hero-image.jpg';

export default {
  data,
  links,
  hero: { media: { image } },
};
